import { render } from "./FilterSlide.vue?vue&type=template&id=5087fbf0&ts=true"
import script from "./FilterSlide.vue?vue&type=script&lang=ts"
export * from "./FilterSlide.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Vyvoj\\temporary\\htdocs\\dev.poski.loc\\clevero.cz\\trunk\\www\\frontend\\CID\\dekstone\\klasik-2020\\js\\libraries\\store-catalog\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__